/**
 * Legend Component
 * 
 * Displays a color-coded legend explaining state status indicators
 */

import React from 'react';
import '../styles/legend.css';

export function Legend() {
  const legendItems = [
    {
      color: '#319B42', // PANTONE 7739C - Green
      label: 'Available Today',
      description: 'Click to view state data'
    },
    {
      color: '#004986', // PANTONE 2186C - Blue
      label: 'Coming Soon! - Early 2026',
      description: 'Data collection in progress'
    },
    {
      color: '#5B6770', // PANTONE 431C - Grey
      label: 'Not enough lotto data available',
      description: 'No plans to collect data'
    }
  ];

  return (
    <div className="map-legend" role="region" aria-label="Map legend">
      <h3 className="legend-title">State Status</h3>
      <div className="legend-items">
        {legendItems.map((item, index) => (
          <div key={index} className="legend-item">
            <div 
              className="legend-color-box" 
              style={{ backgroundColor: item.color }}
              aria-hidden="true"
            />
            <div className="legend-text">
              <div className="legend-label">{item.label}</div>
              <div className="legend-description">{item.description}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
